export const ReferralEndpoint = 'referral-code'
